import { palette } from 'cds/styles';
import { FC } from 'react';
import styled from 'styled-components';

const Section6: FC = () => {
  return (
    <L_Section4>
      <div>
        <Title bold fontSize="2.4rem">
          클래스유에는 모든 교육이 다 있습니다.
        </Title>
      </div>

      <div style={{ marginTop: '4rem' }}>
        <Span strong>실무에 바로 써먹을 수 있는 직무 콘텐츠부터</Span>
        <br />
        <Span strong>삶의 질 향상을 돕는 자기 계발 강의와 법정교육까지!</Span>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <Span>기업에 꼭 필요한 </Span>
        <Span strong>클래스유만의 6만 여개의 콘텐츠</Span>
        <Span>로</Span>
        <br />
        <Span>임직원이 한 층 더 성장합니다.</Span>
      </div>

      <div style={{ margin: ' 6rem auto 0 auto' }}>
        <img
          style={{ maxWidth: '74.5rem' }}
          src="https://classu-files.s3.ap-northeast-2.amazonaws.com/image/1847901/2024-03-25/10%3A28%3A20/lectures.png"
          alt="banner"
        />
      </div>
    </L_Section4>
  );
};

const Span = styled.span<{ bold?: boolean; strong?: boolean; fontSize?: string }>`
  font-weight: ${({ strong, bold }) => (bold ? 600 : strong ? 500 : 300)};
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '1.6rem')};
  color: ${palette.grey50};
`;

const Title = styled(Span)`
  color: ${palette.grey75};
`;

const L_Section4 = styled.section`
  margin: 10rem auto 0 auto;
  padding: 0 2rem;
  text-align: center;
  font-size: 1.6rem;
  & > div > img {
    max-width: 107rem;
    object-fit: cover;
    width: 100%;
  }
`;
export default Section6;

/* 기업에 꼭 필요한 클래스유만의 6만 여개의 콘텐츠로 임직원이 한 층 더 성장합니다. */

// position: absolute;
// width: 451px;
// height: 64px;
// left: 244px;
// top: 1538px;

// font-family: 'S-Core Dream';
// font-style: normal;
// font-weight: 300;
// font-size: 20px;
// line-height: 157.9%;
// /* or 32px */
// text-align: center;

// /* 1d1d1d */
// color: #1D1D1D;
